import { render } from "./GlosarioModal.vue?vue&type=template&id=4c217a46"
import script from "./GlosarioModal.vue?vue&type=script&lang=js"
export * from "./GlosarioModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__